// Lesson 3 - Ethics and Jurisprudence

export const questions = {
  "1. Philosophers and types of ethics": [
    {
      id: 94001,
      question: "Which philosopher is most closely associated with deontological (duty-based) ethics?",
      options: [
        "Immanuel Kant",
        "Aristotle",
        "Jeremy Bentham",
        "John Stuart Mill"
      ],
      correctAnswer: 0
    },
    {
      id: 94002,
      question: "According to utilitarianism, the goal of morality is to:",
      options: [
        "Follow a fixed set of rules regardless of outcomes",
        "Develop virtuous character traits in every individual",
        "Obey authority figures to maintain social order",
        "Achieve the greatest happiness for the greatest number of people"
      ],
      correctAnswer: 3
    },
    {
      id: 94003,
      question: "Which ethical theory judges the morality of an action solely by its consequences or end result?",
      options: [
        "Teleology",
        "Deontology",
        "Normative Ethics",
        "Virtue Ethics"
      ],
      correctAnswer: 0
    },
    {
      id: 94004,
      question: "A dental hygienist tells the truth to a client about a poor prognosis, even though it will cause the client distress, because honesty is a fundamental duty. This reflects which ethical theory?",
      options: [
        "Utilitarianism",
        "Teleology",
        "Deontology",
        "Virtue Ethics"
      ],
      correctAnswer: 2
    },
    {
      id: 94005,
      question: "Which of the following best describes Virtue Ethics?",
      options: [
        "Morality is determined by the consequences of an action on society",
        "Morality is based on adhering to a set of rules and professional duties",
        "Morality is based on the character traits of the person acting",
        "Morality is defined by what maximizes overall social happiness equally"
      ],
      correctAnswer: 2
    },
    {
      id: 94006,
      question: "What is the definition of nonmaleficence?",
      options: [
        "The duty to tell the truth and be honest in all professional situations",
        "The obligation to do no harm; the founding principle for all health professions",
        "The right of clients to make informed decisions about their own care",
        "The duty to promote the well-being of clients and take positive action"
      ],
      correctAnswer: 1
    },
    {
      id: 94007,
      question: "A dental hygienist provides oral hygiene instruction and tobacco cessation counseling to a smoker. This is an example of:",
      options: [
        "Veracity",
        "Beneficence",
        "Autonomy",
        "Fidelity"
      ],
      correctAnswer: 1
    },
    {
      id: 94008,
      question: "Which ethical principle refers to a client's right to make informed decisions about their own healthcare without coercion?",
      options: [
        "Fidelity",
        "Confidentiality",
        "Autonomy",
        "Paternalism"
      ],
      correctAnswer: 2
    },
    {
      id: 94009,
      question: "A hygienist informs a client that a mistake was made during treatment, even though it will lead to an uncomfortable conversation. This best demonstrates:",
      options: [
        "Veracity",
        "Paternalism",
        "Fidelity",
        "Justice"
      ],
      correctAnswer: 0
    },
    {
      id: 94010,
      question: "Which principle is described as \"faithfulness\" and includes the obligation to keep implied or explicit promises?",
      options: [
        "Fidelity",
        "Veracity",
        "Integrity",
        "Beneficence"
      ],
      correctAnswer: 0
    },
    {
      id: 94011,
      question: "A hygienist advocates for programs that provide dental care to low-income populations. This reflects which ethical principle?",
      options: [
        "Autonomy",
        "Justice",
        "Confidentiality",
        "Nonmaleficence"
      ],
      correctAnswer: 1
    },
    {
      id: 94012,
      question: "Which of the following best defines paternalism/parentalism?",
      options: [
        "Maintaining strict confidentiality even when it is personally inconvenient",
        "Providing the client with all available treatment options without personal bias",
        "Making decisions for a client to protect them, which may conflict with their autonomy",
        "Reporting errors in a client's chart and informing the supervising dentist promptly"
      ],
      correctAnswer: 2
    },
    {
      id: 94013,
      question: "What is the primary focus of metaethics?",
      options: [
        "Applying ethical principles directly to professional codes of conduct",
        "Establishing norms that guide human behaviour in specific situations",
        "Exploring the nature of moral judgments and the structure of moral concepts",
        "Determining whether individual professional actions are right or wrong"
      ],
      correctAnswer: 2
    },
    {
      id: 94014,
      question: "Which term refers to a Latin phrase meaning \"at first glance,\" describing duties determined by the present situation and circumstances?",
      options: [
        "Prima Facie",
        "Normative Ethics",
        "Beneficence",
        "Veracity"
      ],
      correctAnswer: 0
    },
    {
      id: 94015,
      question: "Billing an insurance company for services that were not performed is an example of:",
      options: [
        "Overtreatment",
        "Substandard Care",
        "Fraud",
        "Maleficence"
      ],
      correctAnswer: 2
    },
    {
      id: 94016,
      question: "Performing a \"prophy\" on a client with active periodontitis instead of necessary scaling and root planing is an example of:",
      options: [
        "Overtreatment",
        "Ethical Distress",
        "Fraud",
        "Substandard Care"
      ],
      correctAnswer: 0
    },
    {
      id: 94017,
      question: "A hygienist knows a broken sterilizer must be reported but fears retaliation from their employer. This situation describes:",
      options: [
        "Ethical Dilemma",
        "Substandard Care",
        "Paternalism",
        "Ethical Distress"
      ],
      correctAnswer: 3
    },
    {
      id: 94018,
      question: "An ethical dilemma differs from ethical distress in that an ethical dilemma involves:",
      options: [
        "Knowing the right action but feeling unable to perform it due to external pressure",
        "A violation of the standards of practice when treating a client in a clinical setting",
        "An employer directing a hygienist to perform procedures outside their scope of practice",
        "Equally compelling reasons for two or more courses of action, creating a conflict between principles"
      ],
      correctAnswer: 3
    },
    {
      id: 94019,
      question: "In Kohlberg's model, at which level do most adults in society operate?",
      options: [
        "Preconventional Level",
        "Conventional Level",
        "Postconventional Level",
        "Transitional Level"
      ],
      correctAnswer: 1
    },
    {
      id: 94020,
      question: "Which stage of Kohlberg's moral development is characterized by obeying rules to avoid punishment?",
      options: [
        "Stage 2 - Individualism & Exchange",
        "Stage 1 - Punishment & Obedience Orientation",
        "Stage 3 - Good Boy/Good Girl Orientation",
        "Stage 4 - Law & Order Orientation"
      ],
      correctAnswer: 1
    },
    {
      id: 94021,
      question: "Kohlberg's Stage 5 (Social Contract Orientation) falls under which level?",
      options: [
        "Preconventional Level",
        "Conventional Level",
        "Transitional Level",
        "Postconventional Level"
      ],
      correctAnswer: 3
    },
    {
      id: 94022,
      question: "Approximately what percentage of the population reaches Stage 6 (Universal Ethical Principles) in Kohlberg's model?",
      options: [
        "Less than 10% of the population reaches this stage",
        "About 30% of the population reaches this stage",
        "About 20% of the population reaches this stage",
        "About 50% of the population reaches this stage"
      ],
      correctAnswer: 0
    },
    {
      id: 94023,
      question: "What is the correct order of the FIRST three steps in the 8-step Ethical Decision-Making Model?",
      options: [
        "Gather Information -> Identify the Problem -> Identify Options",
        "Clarify the Problem -> Gather Information -> Identify the Problem",
        "Identify the Problem -> Gather Information -> Clarify the Problem",
        "Identify Options -> Assess Options -> Identify the Problem"
      ],
      correctAnswer: 2
    },
    {
      id: 94024,
      question: "Which step of the 8-step Ethical Decision-Making Model involves evaluating the pros and cons of each possible course of action?",
      options: [
        "Step 3 - Clarify the Problem",
        "Step 5 - Assess Options",
        "Step 6 - Choose a Course of Action",
        "Step 4 - Identify Options"
      ],
      correctAnswer: 1
    },
    {
      id: 94025,
      question: "What is the FINAL step of the 8-step Ethical Decision-Making Model?",
      options: [
        "Choose a Course of Action",
        "Identify Options",
        "Implement the Action",
        "Evaluate Outcomes"
      ],
      correctAnswer: 3
    },
    {
      id: 94026,
      question: "Which of the following is NOT within the dental hygiene scope of practice?",
      options: [
        "Assessment of teeth and adjacent tissues",
        "Providing preventive and therapeutic treatment",
        "Performing orthodontic procedures under an order",
        "Diagnosing diseases or disorders"
      ],
      correctAnswer: 3
    },
    {
      id: 94027,
      question: "Which of the following is considered a NOT-controlled act that can be performed by anyone?",
      options: [
        "Providing oral hygiene instruction to clients",
        "Performing restorative procedures under an order",
        "Prescribing designated drugs to eligible clients",
        "Scaling teeth and root planing on a client"
      ],
      correctAnswer: 0
    },
    {
      id: 94028,
      question: "A standing order differs from a regular order in that a standing order:",
      options: [
        "Authorizes a hygienist to perform a specific procedure for one named client only",
        "Allows a hygienist to diagnose conditions without consulting the supervising dentist",
        "Permits a hygienist to prescribe medications to clients in a long-term care setting",
        "Pre-authorizes a hygienist to perform a procedure for a class of clients meeting set criteria"
      ],
      correctAnswer: 3
    },
    {
      id: 94029,
      question: "Which of the following procedures CANNOT be authorized through a standing order?",
      options: [
        "Fluoride application for qualifying clients",
        "Pit and fissure sealants for qualifying clients",
        "Scaling teeth and root planing for all clients",
        "Taking impressions for study casts for qualifying clients"
      ],
      correctAnswer: 2
    },
    {
      id: 94030,
      question: "The RHPA (Regulated Health Professions Act, 1991) governs how many health professions in Ontario?",
      options: [
        "14 professions",
        "26 professions",
        "19 professions",
        "32 professions"
      ],
      correctAnswer: 1
    },
    {
      id: 94031,
      question: "Which document specifically defines the scope of practice for dental hygienists in Ontario?",
      options: [
        "RHPA (Regulated Health Professions Act, 1991)",
        "ADHA Code of Ethics",
        "CDHO Bylaw No. 5",
        "DHA (Dental Hygiene Act, 1991)"
      ],
      correctAnswer: 3
    },
    {
      id: 94032,
      question: "The CDHO Code of Ethics lists five principles. Which of the following is the FIFTH principle unique to the CDHO (compared to the CDHA)?",
      options: [
        "Professionalism",
        "Accountability",
        "Privacy & Confidentiality",
        "Autonomy"
      ],
      correctAnswer: 0
    },
    {
      id: 94033,
      question: "The CDHA Code of Ethics has five principles. How does its fifth principle differ from the CDHO's fifth principle?",
      options: [
        "The CDHA uses Veracity, while the CDHO uses Privacy & Confidentiality",
        "The CDHA uses Nonmaleficence, while the CDHO uses Professionalism",
        "The CDHA uses Beneficence, while the CDHO uses Accountability",
        "The CDHA uses Integrity, while the CDHO uses Professionalism"
      ],
      correctAnswer: 3
    },
    {
      id: 94034,
      question: "Which of the following is a core value listed in the ADHA Code of Ethics but NOT explicitly named in either the CDHO or CDHA Codes?",
      options: [
        "Beneficence",
        "Societal Trust",
        "Autonomy",
        "Accountability"
      ],
      correctAnswer: 1
    },
    {
      id: 94035,
      question: "Which model of professionalism views dentistry as an \"all-knowing profession\"?",
      options: [
        "Commercial Model",
        "Interactive Model",
        "Altruistic Model",
        "Guild Model"
      ],
      correctAnswer: 3
    },
    {
      id: 94036,
      question: "The Interactive Model of professionalism holds that:",
      options: [
        "Dental services are a commodity to be bought and sold in the marketplace",
        "The dental professional is the sole authority on all treatment decisions made",
        "The professional and client have roles of equal moral status in care decisions",
        "Professionals must always defer to the client's preferences regardless of evidence"
      ],
      correctAnswer: 2
    },
    {
      id: 94037,
      question: "Which of the following is NOT listed as a characteristic of a profession?",
      options: [
        "A specialized body of knowledge and intensive academic study",
        "Generating the highest possible profit for its members above all else",
        "A code of ethics and an organized association with standards of practice",
        "Self- and group regulation with external societal recognition of the field"
      ],
      correctAnswer: 1
    },
    {
      id: 94038,
      question: "To maintain their license, dental hygienists in Ontario must complete which program?",
      options: [
        "The CDHO Quality Assurance (QA) Program each cycle",
        "The Ontario Dental Hygiene Licensing Examination (ODHLE) annually",
        "A minimum of 100 hours of supervised clinical practice per year",
        "A written competency exam administered by the RHPA every two years"
      ],
      correctAnswer: 0
    },
    {
      id: 94039,
      question: "By what date must dental hygienists complete the CDHO Self-Assessment Tool each year?",
      options: [
        "March 31st",
        "June 30th",
        "January 31st",
        "December 31st"
      ],
      correctAnswer: 2
    },
    {
      id: 94040,
      question: "Which of the following best describes \"accountability\" in a professional context?",
      options: [
        "Upholding confidentiality even when it is personally inconvenient to do so",
        "The acceptance of responsibility for one's own actions and omissions",
        "Telling the truth and being honest in all professional communications",
        "Prioritizing the client's welfare above the professional's personal interests"
      ],
      correctAnswer: 1
    },
    {
      id: 94041,
      question: "The Postconventional Level in Kohlberg's model is reached by most of society, with the majority of adults operating at Stage 5 or Stage 6.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 94042,
      question: "In Kohlberg's moral development model, Stage 2 (Individualism & Exchange) is characterized by conforming to rules in order to receive rewards.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 94043,
      question: "Under Ontario law, scaling teeth and root planing is a controlled act that dental hygienists are authorized to perform.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 94044,
      question: "The eighth and final step of the Ethical Decision-Making Model is to \"Choose a Course of Action.\"",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 94045,
      question: "Normative ethics is a branch of metaethics that asks \"What is right and wrong?\" and guides human behaviour by establishing norms.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 94046,
      question: "Which of the following best defines maleficence?",
      options: [
        "Causing harm or evil to a client through action or inaction",
        "Failing to disclose relevant information to a client before treatment",
        "Making decisions for a client without consulting them first",
        "Performing a procedure outside the dental hygiene scope of practice"
      ],
      correctAnswer: 0
    },
    {
      id: 94047,
      question: "A dentist decides not to mention an expensive treatment option to a client, assuming the client cannot afford it. This is an example of:",
      options: [
        "Justice",
        "Fidelity",
        "Paternalism",
        "Nonmaleficence"
      ],
      correctAnswer: 2
    },
    {
      id: 94048,
      question: "Which ethical theory is also known as \"nonconsequentialism\"?",
      options: [
        "Teleology",
        "Deontology",
        "Virtue Ethics",
        "Utilitarianism"
      ],
      correctAnswer: 1
    },
    {
      id: 94049,
      question: "Which of the following best describes normative ethics?",
      options: [
        "The study of the origin and meaning of ethical terms such as \"good\" and \"right\"",
        "Ethical thinking that guides human behaviour by establishing norms and asking \"What is right and wrong?\"",
        "The analysis of moral judgments without prescribing specific conduct or behavior",
        "A branch of philosophy that explores whether objective moral truths can exist"
      ],
      correctAnswer: 1
    },
    {
      id: 94050,
      question: "A hygienist promises a client to research a new whitening product and provide information at the next appointment, and follows through on this promise. This demonstrates:",
      options: [
        "Veracity",
        "Beneficence",
        "Autonomy",
        "Fidelity"
      ],
      correctAnswer: 3
    },
    {
      id: 94051,
      question: "Ensuring that instruments are sharp to avoid tissue tearing and trauma during treatment reflects which ethical principle?",
      options: [
        "Autonomy",
        "Veracity",
        "Nonmaleficence",
        "Accountability"
      ],
      correctAnswer: 2
    },
    {
      id: 94052,
      question: "Which of the following examples best illustrates the principle of confidentiality?",
      options: [
        "A hygienist advocates for equitable access to dental care in the community",
        "A hygienist refrains from discussing a client's medical history with family or friends",
        "A hygienist follows through on all treatment promises made to clients",
        "A hygienist documents errors immediately and informs the supervising dentist"
      ],
      correctAnswer: 1
    },
    {
      id: 94053,
      question: "In Kohlberg's model, Stage 3 (Good Boy/Good Girl Orientation) is primarily motivated by:",
      options: [
        "Avoiding punishment from authority figures in positions of power",
        "Seeking personal rewards and satisfying individual self-interests",
        "Conforming to win approval and avoid disapproval from others",
        "Upholding social order and fulfilling duty to society as a whole"
      ],
      correctAnswer: 2
    },
    {
      id: 94054,
      question: "Which stage in Kohlberg's model is characterized by the belief that rules should be based on mutual agreement and can be changed if they no longer serve the community?",
      options: [
        "Stage 3 - Good Boy/Good Girl Orientation",
        "Stage 4 - Law & Order Orientation",
        "Stage 5 - Social Contract Orientation",
        "Stage 6 - Universal Ethical Principles"
      ],
      correctAnswer: 2
    },
    {
      id: 94055,
      question: "In Kohlberg's Stage 6, morality is based on:",
      options: [
        "Obeying rules to maintain social order and avoid legal consequences",
        "Abstract, universal principles of justice and compassion regardless of law",
        "Seeking mutual benefit through individual agreements with other people",
        "Conforming to social norms in order to gain approval from the community"
      ],
      correctAnswer: 1
    },
    {
      id: 94056,
      question: "Which level of Kohlberg's moral development is associated with children?",
      options: [
        "Postconventional Level",
        "Conventional Level",
        "Transitional Level",
        "Preconventional Level"
      ],
      correctAnswer: 3
    },
    {
      id: 94057,
      question: "Which of the following describes Step 4 of the 8-step Ethical Decision-Making Model?",
      options: [
        "Evaluating the pros and cons of each possible course of action",
        "Carrying out the chosen decision thoughtfully and sensitively",
        "Brainstorming the various possible courses of action available",
        "Identifying the ethical principles at stake in the situation"
      ],
      correctAnswer: 2
    },
    {
      id: 94058,
      question: "Step 6 of the 8-step Ethical Decision-Making Model requires the hygienist to:",
      options: [
        "Collect relevant facts, policies, laws, and stakeholder perspectives",
        "Identify the nature of the ethical challenge in a preliminary way",
        "Evaluate outcomes and assess the consequences of the decision",
        "Decide on and be able to justify a chosen course of action"
      ],
      correctAnswer: 3
    },
    {
      id: 94059,
      question: "Which step of the 8-step Ethical Decision-Making Model involves collecting relevant facts, policies, and laws?",
      options: [
        "Step 1 - Identify the Problem",
        "Step 2 - Gather Information",
        "Step 3 - Clarify the Problem",
        "Step 5 - Assess Options"
      ],
      correctAnswer: 1
    },
    {
      id: 94060,
      question: "Using broken or dull instruments, or not spending adequate time to properly debride teeth, is an example of:",
      options: [
        "Fraud",
        "Overtreatment",
        "Substandard Care",
        "Maleficence"
      ],
      correctAnswer: 2
    },
    {
      id: 94061,
      question: "Which of the following correctly describes what a regular order authorizes?",
      options: [
        "A hygienist to perform a specific procedure for a defined class of clients",
        "A hygienist to diagnose a condition and determine necessary treatment",
        "A hygienist to perform a specific procedure for one specific named client",
        "A hygienist to prescribe designated drugs in a long-term care facility"
      ],
      correctAnswer: 2
    },
    {
      id: 94062,
      question: "How many Controlled Acts are outlined under the RHPA?",
      options: [
        "5 controlled acts",
        "10 controlled acts",
        "14 controlled acts",
        "26 controlled acts"
      ],
      correctAnswer: 2
    },
    {
      id: 94063,
      question: "Which of the following procedures is a controlled act that dental hygienists in Ontario are authorized to perform?",
      options: [
        "Taking a client's blood pressure reading",
        "Providing oral hygiene instruction to a client",
        "Applying fluoride to a client's teeth",
        "Scaling teeth and root planing including curetting surrounding tissue"
      ],
      correctAnswer: 3
    },
    {
      id: 94064,
      question: "The CDHO's primary mission is best described as:",
      options: [
        "Training and licensing dental hygiene students in Ontario",
        "Regulating the profession in the interest of the public's health and safety",
        "Providing insurance and liability coverage to registered hygienists",
        "Promoting the professional interests and wages of dental hygienists"
      ],
      correctAnswer: 1
    },
    {
      id: 94065,
      question: "Which of the following documents is described as the overarching law that applies to all regulated health professions in Ontario?",
      options: [
        "DHA (Dental Hygiene Act, 1991)",
        "CDHO Code of Ethics",
        "RHPA (Regulated Health Professions Act, 1991)",
        "CDHO Bylaw No. 5"
      ],
      correctAnswer: 2
    },
    {
      id: 94066,
      question: "What does CDHO Bylaw No. 5 primarily govern?",
      options: [
        "The ethical principles that guide the conduct of all dental hygiene registrants",
        "The scope of practice and controlled acts for dental hygienists in Ontario",
        "The internal rules for the administration and operation of the College itself",
        "The overarching framework for all regulated health professions in Ontario"
      ],
      correctAnswer: 2
    },
    {
      id: 94067,
      question: "Which of the following is the FIRST principle listed in both the CDHO and CDHA Codes of Ethics?",
      options: [
        "Autonomy",
        "Accountability",
        "Professionalism",
        "Beneficence"
      ],
      correctAnswer: 3
    },
    {
      id: 94068,
      question: "Which of the following is a core value in the ADHA Code of Ethics?",
      options: [
        "Veracity",
        "Professionalism",
        "Integrity",
        "Prima Facie"
      ],
      correctAnswer: 0
    },
    {
      id: 94069,
      question: "What is the Commercial Model of professionalism?",
      options: [
        "A model viewing dental services as a commodity to be bought and sold",
        "A model viewing the dentist as the sole authority on all clinical decisions",
        "A model viewing the professional and client as having equal moral status",
        "A model viewing the profession as dedicated to altruism above self-interest"
      ],
      correctAnswer: 0
    },
    {
      id: 94070,
      question: "Which of the following is listed as a principle of professionalism?",
      options: [
        "Consequentialism",
        "Altruism",
        "Teleology",
        "Prima Facie"
      ],
      correctAnswer: 1
    },
    {
      id: 94071,
      question: "Which of the following is included in the definition of professionalism according to the CDHO Code of Ethics (Principle V)?",
      options: [
        "Prioritizing the hygienist's personal financial interests in clinical decisions",
        "Serving the client and the public good through committed professional practice",
        "Advocating for reduced regulatory oversight of dental hygiene in Ontario",
        "Limiting participation in continuing education to once per licensing cycle"
      ],
      correctAnswer: 1
    },
    {
      id: 94072,
      question: "Which of the following is NOT one of the three core components of professionalism as summarized in the study notes?",
      options: [
        "Be profitable",
        "Be competent",
        "Be honest",
        "Be fair"
      ],
      correctAnswer: 0
    },
    {
      id: 94073,
      question: "Which of the following is an example of integrity?",
      options: [
        "A hygienist adheres to a strict ethical code with honesty and consistency of character",
        "A hygienist advocates for fair distribution of dental resources in the community",
        "A hygienist fulfills a promise made to a client at the previous appointment",
        "A hygienist makes decisions for a client to protect them from unnecessary worry"
      ],
      correctAnswer: 0
    },
    {
      id: 94074,
      question: "Which of the following is an example of a Prima Facie duty being overridden?",
      options: [
        "A hygienist tells the truth to a client because honesty is always required",
        "A hygienist withholds the truth to prevent serious harm to a third party",
        "A hygienist follows all professional rules regardless of the current situation",
        "A hygienist applies universal ethical principles that never change in any context"
      ],
      correctAnswer: 1
    },
    {
      id: 94075,
      question: "Which of the following examples illustrates maleficence?",
      options: [
        "Performing an unnecessary and painful procedure on a client",
        "Failing to research treatment alternatives before making a recommendation",
        "Discussing a client's health information with another registered professional",
        "Delaying a referral to a specialist due to an administrative scheduling error"
      ],
      correctAnswer: 0
    },
    {
      id: 94076,
      question: "A client refuses radiographic images after the hygienist has explained the risks and benefits. Respecting this decision reflects which principle?",
      options: [
        "Autonomy",
        "Beneficence",
        "Fidelity",
        "Justice"
      ],
      correctAnswer: 0
    },
    {
      id: 94077,
      question: "Which of the following is a characteristic of a profession?",
      options: [
        "Generating the highest profit for its members",
        "Operating without external societal oversight or regulation",
        "Determining its own standards exclusively based on member preferences",
        "Possessing a specialized body of knowledge gained through intensive academic study"
      ],
      correctAnswer: 3
    },
    {
      id: 94078,
      question: "The principle of justice in dental hygiene is most closely associated with which concept?",
      options: [
        "Keeping promises made to clients in the professional relationship",
        "Making fair and equitable allocation of resources among individuals",
        "Promoting the overall happiness of the greatest number of people",
        "Following the rules and duties of the profession regardless of outcome"
      ],
      correctAnswer: 1
    },
    {
      id: 94079,
      question: "A hygienist documents a treatment error in a client's chart and immediately informs the supervising dentist. This is an example of:",
      options: [
        "Accountability",
        "Veracity",
        "Autonomy",
        "Fidelity"
      ],
      correctAnswer: 0
    },
    {
      id: 94080,
      question: "Which of the following is a requirement of the CDHO Quality Assurance Program?",
      options: [
        "Passing a written licensing exam administered by the RHPA every two years",
        "Maintaining a Professional Portfolio as proof of continuing education participation",
        "Completing a minimum of 100 clinical hours per year under direct supervision",
        "Retaking the national dental hygiene licensing examination every five years"
      ],
      correctAnswer: 1
    },
    {
      id: 94081,
      question: "What is the relationship between normative ethics and metaethics?",
      options: [
        "Normative ethics is completely independent of and unrelated to metaethics",
        "Metaethics is a practical subset of normative ethics focused on daily decisions",
        "Metaethics guides daily behaviour, while normative ethics studies moral concepts",
        "Normative ethics is a branch of metaethics"
      ],
      correctAnswer: 3
    },
    {
      id: 94082,
      question: "Which of the following is a key distinction between ethical distress and an ethical dilemma?",
      options: [
        "In ethical distress the right action is known but feels blocked; in a dilemma the right action is unclear",
        "Ethical distress involves two competing ethical principles, while a dilemma involves external pressure",
        "Ethical distress is caused by professional negligence, while a dilemma results from policy conflicts",
        "A dilemma requires following established procedures, while distress requires personal judgment only"
      ],
      correctAnswer: 0
    },
    {
      id: 94083,
      question: "According to the study notes, which of the following is an example of an ethical dilemma?",
      options: [
        "A hygienist fears employer retaliation for reporting a broken sterilizer",
        "A hygienist knowingly bills for services that were never performed",
        "A hygienist performs a cleaning instead of the required scaling and root planing",
        "The principle of confidentiality conflicts with concern for the welfare of a third party"
      ],
      correctAnswer: 3
    },
    {
      id: 94084,
      question: "Which of the following professional traits is listed in the study notes?",
      options: [
        "Reliability and Responsibility",
        "Assertiveness and Self-Promotion",
        "Financial Acuity and Business Awareness",
        "Task Efficiency and Time Management"
      ],
      correctAnswer: 0
    },
    {
      id: 94085,
      question: "Telling a client a \"little white lie\" to prevent unnecessary worry because you believe it will do more good than the truth is an example of which ethical theory?",
      options: [
        "Deontology",
        "Virtue Ethics",
        "Metaethics",
        "Teleology"
      ],
      correctAnswer: 3
    },
    {
      id: 94086,
      question: "Which of the following is NOT listed as a core value in the ADHA Code of Ethics?",
      options: [
        "Professionalism",
        "Individual Autonomy",
        "Societal Trust",
        "Justice and Fairness"
      ],
      correctAnswer: 0
    },
    {
      id: 94087,
      question: "Which of the following is a controlled act that dental hygienists are authorized to perform only under an order?",
      options: [
        "Polishing teeth",
        "Taking blood pressure",
        "Providing oral hygiene instruction",
        "Performing restorative procedures"
      ],
      correctAnswer: 3
    },
    {
      id: 94088,
      question: "The Interactive Model of professionalism views the dentist as the sole authority and the client as a passive recipient of care.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 94089,
      question: "The DHA (Dental Hygiene Act, 1991) is the profession-specific act that defines the scope of practice for dental hygienists in Ontario.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 94090,
      question: "Dental hygienists in Ontario are permitted to diagnose diseases or disorders as part of their authorized scope of practice.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 94091,
      question: "According to Kohlberg's model, approximately 20% of the total population reaches the Postconventional Level of moral development.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 94092,
      question: "Fidelity refers to the duty to tell the truth and be honest in all professional situations.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 94093,
      question: "The RHPA (Regulated Health Professions Act, 1991) governs 26 regulated health professions in Ontario.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 94094,
      question: "Substandard care and overtreatment describe the same type of professional misconduct in dental hygiene practice.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 94095,
      question: "The fifth principle in the CDHA Code of Ethics is Integrity, while the fifth principle in the CDHO Code of Ethics is Professionalism.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
  ]
};
